import React, { useContext } from "react"
import { CheckboxStep } from "#/components/carrot-card-cost-share/steps/variants/CheckboxStep"
import { useIntl } from "react-intl"
import { CarrotCardCostSharePreAuthContext } from "#/components/carrot-card-cost-share/state/CarrotCardCostSharePreAuthContext"
import { JourneyTypes } from "#/components/get-reimbursed/steps/ExpenseJourneyTypes"
import { Link } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"
export function PleaseConfirmTwoThingsStep(): JSX.Element {
  const intl = useIntl()
  const {
    formState: { journeyType }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const journeyContent: Partial<Record<JourneyTypes, { care: string; link: string }>> = {
    [JourneyTypes.GENDER_AFFIRMING_CARE]: { care: "gender-affirming care", link: DbgPaths.GENDER_AFFIRMING_CARE },
    [JourneyTypes.LOW_TESTOSTERONE]: { care: "low testosterone treatment", link: DbgPaths.LOW_TESTOSTERONE },
    [JourneyTypes.MENOPAUSE]: { care: "menopause treatment", link: DbgPaths.MENOPAUSE }
  }

  return (
    <CheckboxStep
      title={intl.formatMessage({ defaultMessage: "Please confirm two things." })}
      description={intl.formatMessage({ defaultMessage: "We need your confirmation to process your expense." })}
      primaryCheckBoxLabel={intl.formatMessage(
        {
          defaultMessage: "This expense is related to {careType} recommended by my provider."
        },
        { careType: journeyContent[journeyType as JourneyTypes]?.care }
      )}
      secondaryCheckBoxLabel={intl.formatMessage(
        {
          defaultMessage: "My provider meets Carrot's <link>eligibility requirements.</link>"
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={journeyContent[journeyType as JourneyTypes]?.link}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
